import { signal } from '@preact/signals';

type IBrandSetting = {
  brand: string;
  apiUrl: string;
  cookiePolicyUrl: string;
  placement: 'left' | 'right';
  buttonCopy: string;
  useBrandColors: boolean;
  variant: 'normal' | 'compact';
};

const brandSettingsSignal = signal<IBrandSetting>({
  brand: null,
  apiUrl: null,
  cookiePolicyUrl: null,
  placement: 'left',
  buttonCopy: 'Feedback',
  useBrandColors: false,
  variant: 'normal',
});

export const setupBrandSettings = (values) => {
  brandSettingsSignal.value.brand = values['brand'] ?? process.env.PREACT_APP_BRAND;
  brandSettingsSignal.value.apiUrl = values['apiUrl'] || process.env.PREACT_APP_API_URL;
  brandSettingsSignal.value.cookiePolicyUrl =
    values['cookiePolicyUrl'] || process.env.PREACT_APP_COOKIE_POLICY_URL;
  brandSettingsSignal.value.placement = values['placement'] || 'left';
  brandSettingsSignal.value.buttonCopy = values['buttonCopy'];
  brandSettingsSignal.value.useBrandColors = values['useBrandColors'] === 'true';
  brandSettingsSignal.value.variant = values['variant'];
};

export const useBrandSettings = () => {
  return brandSettingsSignal.value;
};
